/* The Checks tab. Tokens only (ADR-0007). Status is a chip with a glyph and a word. */

.parts {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--gap);
  margin: 0 0 14px;
  padding: 0;
  list-style: none;
}

.part {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  min-height: var(--target-min);
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.part:hover {
  border-color: var(--line-2);
  background: var(--panel-2);
}

.part[aria-pressed="true"] {
  border-color: var(--accent);
  background: var(--accent-w);
}

.part:focus-visible,
.filter:focus-visible,
.again:focus-visible,
.fixLink:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.partLabel {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 650;
}

.partCount {
  font-size: var(--t-figure);
  line-height: 1.1;
  font-variant-numeric: lining-nums tabular-nums;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 12px;
}

.filter {
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink-2);
  font: inherit;
  font-size: var(--t-dense);
  cursor: pointer;
}

.filter[aria-pressed="true"] {
  border-color: var(--accent);
  background: var(--accent-w);
  color: var(--ink);
  font-weight: 650;
}

.again {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  cursor: pointer;
}

.again:disabled {
  color: var(--disabled);
  cursor: default;
}

.group {
  margin: 0 0 14px;
}

.groupHead {
  margin: 0 0 6px;
  color: var(--ink);
  font-size: var(--t-head);
  font-weight: 650;
}

.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--line);
}

.check {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 0;
  border-bottom: 1px solid var(--line);
  min-width: 0;
}

.checkHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
}

.checkTitle {
  color: var(--ink);
  font-size: var(--t-body);
  font-weight: 600;
}

.lead {
  margin: 0;
  color: var(--ink-2);
  font-size: var(--t-dense);
  line-height: 1.45;
  max-width: 80ch;
  overflow-wrap: anywhere;
}

.fixes {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 2px 0 0;
  padding: 0;
  list-style: none;
}

.fix {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 12px;
  font-size: var(--t-dense);
}

.fixDetail {
  color: var(--ink-2);
  overflow-wrap: anywhere;
}

.fixLink {
  color: var(--accent);
  font-weight: 650;
  text-decoration: underline;
}

.refused,
.more {
  color: var(--muted);
  font-size: var(--t-min);
}

.more2 {
  color: var(--muted);
  font-size: var(--t-min);
}

.more2 summary {
  cursor: pointer;
  color: var(--ink-2);
  font-weight: 600;
}

.more2 p {
  margin: 6px 0 0;
  max-width: 80ch;
  line-height: 1.5;
}

.cite {
  color: var(--muted);
}

.stamp {
  margin: 12px 0 0;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
}

@media (width <= 900px) {
  .parts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (width <= 560px) {
  .parts {
    grid-template-columns: minmax(0, 1fr);
  }

  .filter,
  .again {
    min-height: var(--target-touch);
  }
}
